import { applyMiddleware, combineReducers, compose, createStore as _createStore } from 'redux';
import { ThunkDispatch, withExtraArgument } from 'redux-thunk';
import { filterReducer, noopReducer, newBuildingsReducer } from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, TReduxActions, TReduxStore } from '../../types/redux';
import { getDeveloper, getFsk } from '../../selectors';
import { userReducer } from '../../reducers/user';
import { lkTypeReducer } from '../../reducers/lkType';
import { developerV2Reducer } from '../../reducers/developerV2';
import { reviewsDetailsReducer } from '../../reducers/reviewsDetails';
import { developerValuationReducer } from '../../reducers/developerValuation';

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IApplicationContext, TReduxActions>;
}

let storeReminder: TReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param context – IApplicationContext
 * @param debugEnabled – включение дебаг мода
 */
export function createReduxStore(initialState: IApplicationState, context: IApplicationContext, debugEnabled: boolean) {
  const reducers = combineReducers({
    filters: filterReducer,
    developer: noopReducer(getDeveloper(initialState)),
    developerV2: developerV2Reducer(initialState.developerV2),
    common: noopReducer(initialState.common),
    newBuildings: newBuildingsReducer,
    fsk: noopReducer(getFsk(initialState)),
    user: userReducer,
    lkType: lkTypeReducer,
    reviewsDetails: reviewsDetailsReducer,
    developerValuation: developerValuationReducer,
  });

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  const createStore = (): TReduxStore =>
    _createStore<IApplicationState, TReduxActions, IThunkExt, {}>(reducers, initialState, storeEnchancers);

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(reducers);

    return storeReminder;
  }

  return createStore();
}
